import {
  applyChosen
} from './modules/selects_helper';
import {
  defaultCountryCode
} from './modules/country_code';
import { phoneinput } from "./intl-tel-input";
import { phoneDigits } from "./modules/validations";
import { animateSelects } from "./inputs_group_animate"

$(document).on('click', 'form .add-phone-field', function (e) {

  addFields($('.phone-fields-wrapper'), false, e, this);
  hideAddFields($('.phone-fields-wrapper '), $('.loan-close'));

});

$(document).on('click', 'form .add-working-hours-fields-edit-page', function (e) {

  addFields($('.work-schedules-wrapper'), true, e, this);
  hideAddFields($('.work-schedules-wrapper'), $('.working-hour-close'));

});


$(document).on('click', 'form .remove-fields', function (e) {
  e.preventDefault();

  var closeFieldset = $(this).closest('fieldset');
  closeFieldset.next().val('1');
  closeFieldset.remove();

  checkNumberOfFields($('.work-schedules-wrapper'), $('.working-hour-close'));
  checkNumberOfFields($('.phone-fields-wrapper '), $('.loan-close'));

  $('form .add_fields').show();
});

$(function () {

  hideAddFields($('.work-schedules-wrapper'), $('.working-hour-close'));
  hideAddFields($('.phone-fields-wrapper '), $('.loan-close'));

});

function hideAddFields(wrapper, close) {
  let FieldsetCount = wrapper.find('fieldset:visible');

  if (FieldsetCount.length >= 3) {
    wrapper.find('.add_fields').hide();
    FieldsetCount.addClass('removable');
  } else if (FieldsetCount.length > 1) {
    FieldsetCount.addClass('removable');
  } else {
    close.hide();
  }
}

function addFields(wrapper, useChosen, e, obj) {
  let regexp;
  let time;
  let FieldsetCount = wrapper.find('fieldset:visible').length;

  if (FieldsetCount < 3) {
    e.preventDefault();

    time = new Date().getTime();
    regexp = new RegExp(`${$(obj).data('id')}`, 'g');
    $(obj).before($(obj).data('fields').replace(regexp, time));

    if (useChosen) {
      applyChosen($('.chosen-single-select'));
      animateSelects();
    } else {
      phoneinput($(".phone-input"));
    }

    phoneDigits();
    checkNumberOfFields($('.work-schedules-wrapper'), $('.working-hour-close'));
    checkNumberOfFields($('.phone-fields-wrapper '), $('.loan-close'));

  }

}


function checkNumberOfFields(wrapper, close) {
  if (wrapper.find('fieldset').length <= 1) {
    close.hide();
    wrapper.find('fieldset').removeClass('removable');
  } else {
    close.show();
    wrapper.find('fieldset').addClass('removable');
  }
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/add_fields.js